// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_root__LcA\\+Y {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  width: 100%;
}

.styles_chatWrapper__f7qU5 {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.styles_error__6uT2J {
  align-items: center;
  color: #666;
  display: flex;
  font-size: 14px;
  height: 100vh;
  justify-content: center;
  padding: 16px;
  text-align: center;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/modules/standalone-chat/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,cAAA;EACA,aAAA;AACJ;;AAEA;EACI,mBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AACJ","sourcesContent":[".root {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    overflow: hidden;\n    width: 100%;\n}\n\n.chatWrapper {\n    display: flex;\n    flex: 1 1 auto;\n    min-height: 0;\n}\n\n.error {\n    align-items: center;\n    color: #666;\n    display: flex;\n    font-size: 14px;\n    height: 100vh;\n    justify-content: center;\n    padding: 16px;\n    text-align: center;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `styles_root__LcA+Y`,
	"chatWrapper": `styles_chatWrapper__f7qU5`,
	"error": `styles_error__6uT2J`
};
export default ___CSS_LOADER_EXPORT___;
